(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-user-state.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-user-state.js');

'use strict';

const {
  OverviewUserState
} = svs.components.marketplaceCompetition.overviewHero.constants;
const {
  REG_CLOSED_DRAW_FINALIZED,
  REG_OPEN_DRAW_FINALIZED
} = svs.components.marketplaceCompetition.competitionHandler.common.constants.competitionStates;

const useUserState = _ref => {
  let {
    competition,
    overrides = {}
  } = _ref;
  let {
    currentDrawNumber
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  const competitionStatus = competition === null || competition === void 0 ? void 0 : competition.status;
  if (competitionStatus && (competitionStatus === REG_CLOSED_DRAW_FINALIZED || competitionStatus === REG_OPEN_DRAW_FINALIZED)) {
    currentDrawNumber = competition.details.drawNumberList[competition.details.drawNumberList.findIndex(drawNumber => drawNumber === currentDrawNumber) - 1];
  }
  const playerCompetitions = svs.components.marketplaceCompetition.services.hooks.usePlayerCompetitions && svs.components.marketplaceCompetition.services.hooks.usePlayerCompetitions();
  const playerDraws = svs.components.marketplaceCompetition.services.hooks.usePlayerCompetitionDraws && svs.components.marketplaceCompetition.services.hooks.usePlayerCompetitionDraws(competition === null || competition === void 0 ? void 0 : competition.id);
  if (!(competition !== null && competition !== void 0 && competition.id)) {
    return;
  }
  if (overrides.userState) {
    return overrides.userState;
  }
  const isUserLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!isUserLoggedIn) {
    return OverviewUserState.IS_NOT_LOGGED_IN;
  }
  const isUserRegisteredInCompetition = competition.id && (playerCompetitions === null || playerCompetitions === void 0 ? void 0 : playerCompetitions[competition.id]);
  if (!isUserRegisteredInCompetition) {
    return OverviewUserState.IS_NOT_REGISTERED;
  }

  const normalizedPlayerDraws = Array.isArray(playerDraws) ? playerDraws.map(draw => Number(draw)) : [];
  const numericCurrentDraw = currentDrawNumber !== null && currentDrawNumber !== undefined ? Number(currentDrawNumber) : null;
  const hasUserSettledBetInCurrentGame = competition.id && numericCurrentDraw && normalizedPlayerDraws.includes(numericCurrentDraw);
  if (!hasUserSettledBetInCurrentGame) {
    return OverviewUserState.HAS_NO_CURRENT_BET;
  }
  return OverviewUserState.HAS_CURRENT_BET;
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hooks.useUserState', useUserState);

 })(window);